/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {getBlackList} from "@/api/BlackList"

export default {
  addBlackList({ commit }, blackList) {
    return new Promise((resolve, reject) => {
      commit('ADD_BLACK_LIST', blackList)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsBlackList({ commit },payload) {
    return new Promise((resolve, reject) => {
        getBlackList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_BLACK_LIST', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
        
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateBlackList({ commit }, blackList) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_BLACK_LIST', blackList)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeBlackList({ commit }, blackListId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_BLACK_LIST', blackListId)
          resolve();
    })
  },
};
